import HomeBannerBlueGradient from "./HomeBannerBlueGradient.svg";
import HomeBannerPinkGradient from "./HomeBannerPinkGradient.svg";
import BannerImg1 from "./BannerImg1.png";
import BannerImg2 from "./BannerImg2.png";
import BannerImg3 from "./BannerImg3.png";
import About1 from "./About1.png";
import About2 from "./About2.png";
import About3 from "./About3.png";
import About4 from "./About4.png";
import homeBannerBG from "./homeBannerBG.svg";
import HomeBlackBg from "./HomeBlackBg.png";
import WorkflowCircle from "./WorkflowCircle.png";
import gridLines from "./gridLines.svg";
import workflowLine from "./workflowLine.png";
import workflowArrow from "./workflowArrow.png";
import collapseBtn from "./collapseBtn.png";
import expandBtn from "./expandBtn.png";
import serviceIcon1 from "./serviceIcon1.png";
import serviceIcon2 from "./serviceIcon2.png";
import serviceIcon3 from "./serviceIcon3.png";
import serviceIcon4 from "./serviceIcon4.png";
import serviceIcon5 from "./serviceIcon5.png";
import serviceIcon6 from "./serviceIcon6.png";
import serviceIcon7 from "./serviceIcon7.png";
import serviceIcon8 from "./serviceIcon8.png";
// import serviceIcon9 from "./serviceIcon9.png";
import webTech1 from "./webTech1.png";
import webTech2 from "./webTech2.png";
import webTech3 from "./webTech3.png";
import webTech4 from "./webTech4.png";
import webTech5 from "./webTech5.png";
import webTech6 from "./webTech6.png";
import webTech7 from "./webTech7.png";
import webTech8 from "./webTech8.png";
import webTech9 from "./webTech9.png";
import work1 from "./work1.png";
import work2 from "./work2.png";
import work3 from "./work3.png";
import work4 from "./work4.png";
import work5 from "./work5.png";
import circularArrowLeft from "./circularArrowLeft.svg";
import circularArrowRight from "./circularArrowRight.svg";
import blog1 from "./blog1.png";
import blog2 from "./blog2.png";
// import blog3 from "./blog3.png";
// import blog4 from "./blog4.png";
import blogBG from "./blogBG.png";
import client1 from "./team1.png";
import clientsBg from "./teamsBg.png";
import client2 from "./team2.png";
import client3 from "./team3.png";
import client2sm from "./team2sm.png";
import nextArrowsm from "./nextArrowsm.svg";
import prevArrowsm from "./prevArrowsm.svg";
import industries1 from "./industries1.png";
import industries2 from "./industries2.png";
import industries3 from "./industries3.png";
import industries4 from "./industries4.svg";
import industries5 from "./industries5.png";
import industries6 from "./industries6.png";
import ServiceBgImg from "./ServiceBgImg.png";
import AboutBgImg from "./AboutBgImg.png";
import horizontalLines from "./horizontalLines.svg";
import VerticalLines from "./VerticalLines.svg";
import BlogArrow from "./BlogArrow.png";

export const home = {
  HomeBannerBlueGradient,
  HomeBannerPinkGradient,
  BannerImg1,
  BannerImg2,
  BannerImg3,
  About1,
  About2,
  About3,
  About4,
  homeBannerBG,
  HomeBlackBg,
  WorkflowCircle,
  gridLines,
  workflowLine,
  workflowArrow,
  collapseBtn,
  expandBtn,
  serviceIcon1,
  serviceIcon2,
  serviceIcon3,
  serviceIcon4,
  serviceIcon5,
  serviceIcon6,
  serviceIcon7,
  serviceIcon8,
  // serviceIcon9,
  webTech1,
  webTech2,
  webTech3,
  webTech4,
  webTech5,
  webTech6,
  webTech7,
  webTech8,
  webTech9,
  work1,
  work2,
  work3,
  work4,
  work5,
  circularArrowLeft,
  circularArrowRight,
  blog1,
  blog2,
  // blog3,
  // blog4,
  blogBG,
  client1,
  clientsBg,
  client2,
  client3,
  client2sm,
  nextArrowsm,
  prevArrowsm,
  industries1,
  industries2,
  industries3,
  industries4,
  industries5,
  industries6,
  ServiceBgImg,
  AboutBgImg,
  horizontalLines,
  VerticalLines,
  BlogArrow,
};
